module.exports = __webpack_public_path__ + "img/small_bear.0962a225.gif";